import * as React from 'react'
import { makeStyles, styled } from '@material-ui/core/styles';
import { colors } from './common';

export const StateLine = () => {
    const classes = useStateStyles();

    return <div className={ classes.stateLine } />
}

export const State = ({ children, color, checked }) => {
    const classes = State.useStyles({ color, checked });

    return (
        <div className={ classes.root }>
            <div className={ classes.circle }>
                { checked ? <div className={ classes.checked } /> : void 0 }
            </div>
            <div className={ classes.label }>{ children }</div>
        </div>
    )
}

State.useStyles = makeStyles({
    root : {
        margin: '8px 4px 8px 4px',
        height: 39,
        position: 'relative'
    },

    checked : {
        color : colors.green,
        height: 5,
        borderWidth: '0 0 1px 1px',
        borderColor: colors.green,
        borderStyle: 'solid',
        width: 9,
        margin: '4px 3px 3px 3px',
        transform: 'rotate(-45deg)',
    },

    circle : {
        width: '17px',
        height: '17px',
        borderRadius: '50%',
        borderColor : ({ color } : any ) => colors[ color ],
        //backgroundColor: ({ color, checked } : any ) => checked ? colors[ color ] : '#fff',
        border: '1px solid #668aa5',
    },

    label :{
        marginTop: '8px',
        position: 'absolute',
        transform: 'translateX(-50%)',
        left:'50%',
        color: ({ color } : any ) => color === 'blue' ? colors[ color ] : colors[ 'grey' ],
        fontFamily: 'Montserrat',
        fontSize: 11,
        textAlign: 'center',
    }
});



export const StateFlow = styled( 'div' )({
    display: "flex",
    justifyContent: 'center',
    alignContent: 'center',
    paddingLeft: 30,
    paddingRight: 30
})

const useStateStyles = makeStyles({
    stateLine : {
        height: '4px',
        borderRadius: '2px',
        width: 30,
        backgroundColor: '#e5f2fa',
        marginTop: 15
    }
});